import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { JsonParseFatalError } from 'libs/end-to-end/src/types/errors/json-parse-fatal-error';

export const jsonParseUnknown = (
  input: string,
): Result<unknown, JsonParseFatalError> => {
  try {
    return okResult(JSON.parse(input) as unknown);
  } catch (error) {
    return errResult({
      errorType: 'JsonParseFatalError',
      errorReason: error instanceof Error ? error.message : 'Unknown error',
    });
  }
};
